import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e640d2c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\嘀嗒嘀关务\\ddd_cms_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e640d2c')) {
      api.createRecord('2e640d2c', component.options)
    } else {
      api.reload('2e640d2c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e640d2c&", function () {
      api.rerender('2e640d2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/setting/userManagement/index.vue"
export default component.exports